import React, { FC } from 'react';

// The node glyph from the Credenco wordmark (src/components/atoms/CredencoLogo.tsx),
// isolated so it can take its colour from the surrounding text.
export const CredencoMark: FC<{size?: number}> = ({size = 26}) => {
    const columns = [4.29, 17.12, 29.87];
    const rows = [4.39, 15.81, 27.29];

    return (
        <svg
            width={size * 34 / 32}
            height={size}
            viewBox="0 0 34 32"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.33}
            aria-hidden="true">
            {rows.map(cy => columns.map(cx => (
                <ellipse key={`${cx}-${cy}`} cx={cx} cy={cy} rx={2.91} ry={2.92}/>
            )))}
            <line x1="26.97" y1="27.22" x2="20.03" y2="27.22"/>
            <line x1="15.07" y1="25.21" x2="6.41" y2="17.93"/>
            <line x1="6.41" y1="13.80" x2="15.07" y2="6.52"/>
            <line x1="20.03" y1="4.39" x2="26.97" y2="4.39"/>
        </svg>
    );
};
